module.exports = __webpack_public_path__ + "img/send-sms-token.1f833252.svg";